import React, { useState, useEffect } from "react";
import "../Form/proposalForm.css";

function range(size = 1, startAt = 0) {
  return Array.from(Array(size).keys()).map((i) => i + startAt);
}

const Pagination = ({
  itemsCount = 1,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  let pagesCount = Math.ceil(itemsCount / pageSize);
  const [pages, setPages] = useState(
    range(pagesCount >= 10 ? 10 : pagesCount, 1)
  );
  useEffect(() => {
    setPages(range(pagesCount >= 10 ? 10 : pagesCount, 1)); // eslint-disable-next-line
  }, [itemsCount]);
  useEffect(() => {
    setPages(range(pagesCount >= 10 ? 10 : pagesCount, 1)); // eslint-disable-next-line
  }, [pageSize]);

  if (pagesCount === 1) return null;

  return (
    <nav>
      <ul className="pagination justify-content-center">
        <li
          className={currentPage - 1 === 0 ? "page-item disabled" : "page-item"}
        >
          <button
            style={{ outline: "none", boxShadow: "none" }}
            className="page-link"
            onClick={() => {
              onPageChange(currentPage - 1);
              if (
                currentPage - 1 < pages[1] &&
                currentPage > 2 &&
                pagesCount >= 10
              ) {
                setPages(range(10, pages[0] - 1));
              }
              if (
                currentPage - 1 < pages[0] &&
                currentPage > 2 &&
                pagesCount >= 10
              ) {
                setPages(range(10, pages[0] - 2));
              }
              if (currentPage === 2 && pagesCount >= 10) {
                setPages(range(10, 1));
              }
            }}
          >
            Previous
          </button>
        </li>
        {pages.map((page) => (
          <li
            key={page}
            className={page === currentPage ? "page-item active" : "page-item"}
          >
            <button
              className="page-link"
              onClick={() => onPageChange(page)}
              style={{
                outline: "none",
                boxShadow: "none",
                textDecoration: "none",
              }}
            >
              {page}
            </button>
          </li>
        ))}
        <li
          className={
            currentPage + 1 >= pagesCount + 1
              ? "page-item disabled"
              : "page-item"
          }
        >
          <button
            style={{ outline: "none", boxShadow: "none" }}
            className="page-link"
            onClick={() => {
              onPageChange(currentPage + 1);
              if (
                currentPage + 1 > pages[pages.length - 2] &&
                currentPage < pagesCount - 1 &&
                pages.length &&
                pagesCount >= 10
              ) {
                setPages(range(10, pages[0] + 1));
              }
              if (
                currentPage + 1 > pages[pages.length - 1] &&
                currentPage < pagesCount - 1 &&
                pages.length &&
                pagesCount >= 10
              ) {
                setPages(range(10, pages[0] + 2));
              }
              if (currentPage === pagesCount - 1 && pagesCount >= 10) {
                setPages(range(10, pagesCount - 9));
              }
            }}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
